import {
  AddressField,
  CityField,
  CountryCodeField,
  EmailField,
  FirstNameField,
  LastNameField,
  NameOnCardField,
  StateField,
  ZipField,
} from '@src/clients/financialSettings/fields/CreditCardFields';
import * as yup from 'yup';

export const CreditCardInputsSchema = yup.object().shape({
  [NameOnCardField.fieldName]: NameOnCardField.validator,
  [EmailField.fieldName]: EmailField.validator,
  [FirstNameField.fieldName]: FirstNameField.validator,
  [LastNameField.fieldName]: LastNameField.validator,
  [AddressField.fieldName]: AddressField.validator,
  [ZipField.fieldName]: ZipField.validator,
  [CityField.fieldName]: CityField.validator,
  [CountryCodeField.fieldName]: CountryCodeField.validator,
  [StateField.fieldName]: StateField.validator,
});

export type CreditCardInputsSchema = yup.InferType<
  typeof CreditCardInputsSchema
>;
